import { Component, OnInit, OnDestroy } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { AdsService } from '@fuse/services/ads/ads.service';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot, Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { CompanyService } from '@fuse/services/company.service';





@Component({
    selector: 'ads',
    templateUrl: './ads.component.html',
    styleUrls: ['./ads.component.scss'],
    animations: fuseAnimations
})
export class AdsComponent implements OnInit, OnDestroy {

    private _unsubscribeAll: Subject<any>;

    routeParams: any;
    onProjectListChanged: BehaviorSubject<any>;
    onFiltersChanged: BehaviorSubject<any>;
    onChipsChanged: BehaviorSubject<any>;

    totalResults = 0;
    searchChips = [];
    projects: any;
    logo: string;
    lang = 'sr';
    companyId = this._companyService.activeCompany.id;

    constructor(
        private _adsService: AdsService,
        private httpClient: HttpClient,
        private _router: Router,
        private _translationLoader: FuseTranslationLoaderService,
        private _companyService: CompanyService
    ) {
        this._unsubscribeAll = new Subject();
    }

    private getTranslations(): void {
        this._translationLoader.getLastLang()
            .then(response => {
                this.lang = response['code'];
                this._translationLoader.getTranslations(this.lang, '2');
            })
            .catch(err => Promise.reject(err))
            .then(() => {
            }, err => {
            });
    }

    ngOnInit(): void {

        this._adsService.getInternalAds(this.companyId)
            .then(data => {
                this.projects = data.data;
                this.totalResults = this.projects.length;
                console.log(this.projects);
            });

        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(value => {
                this._adsService.getInternalAds(this.companyId)
                    .then(response => {
                        this.projects = response.data;
                    });
                this.getTranslations();
            });
        this.getTranslations();

        this._companyService.onCompanyChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe((response) => {
                if (this.companyId !== this._companyService.activeCompany.id ? this._companyService.activeCompany.id : response.id) {
                    this.companyId = this._companyService.activeCompany.id;
                    this._adsService.getInternalAds(this.companyId);
                }
            });
    }





    /**
     * On destroy
     */
    ngOnDestroy(): void {

    }



}
